import React from "react";

const Warning = ({ children }) => {
  return (
    <div
      className={`mt-4 p-3 text-white  border  rounded-md text-sm bg-primary border-primary `}
    >
      {children}
    </div>
  );
};

export default Warning;
